import React from 'react';

export const IF = ({ condition, fallback = <></>, children }) => {
  if (!condition) return fallback;
  return children;
};
